import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import MenuGroup from "aldoo-ra/MenuGroup"
import useSitePlatform from "@components/Site/useSitePlatform"

const ArticleBanner = () => {
  const [platform] = useSitePlatform()

  return (
    <CMSRender
      contentType="BannerCTA"
      match={{ "content.id": "ArticleBannerCTA" }}
      renderItem={(data, id) => (
        <div className="relative w-full h-[154px] flex flex-col md:flex-row items-center justify-evenly bg-primary_lt rounded-[24px] overflow-hidden  py-6">
          <Typography
            variant="body_24"
            className="text-text text-center my-0 z-10"
          >
            {data.text}
          </Typography>

          <MenuGroup
            name="GetAquaMail"
            renderAs="hlist"
            itemWidth="150px"
            itemsAsLinks={false}
            menuItemRender={(item) => {
              if (!item) return null

              const url =
                (item?.link &&
                  item?.link[0]?.parameters &&
                  item?.link[0]?.parameters[platform]) ||
                (item?.link && item?.link[0]?.url)
              return (
                <Button 
                  variant="primary_xl" 
                  className="z-10 whitespace-nowrap"
                >
                  <a href={url} target="_blank">
                    {item?.label}
                  </a>
                </Button>
              )
            }}
          />

          <img
            src={data.image}
            alt={data.label}
            className="absolute left-0 h-[154px] w-auto object-contain z-0"
            style={{
              height: "154px", // Fixed height for the image
              width: "auto", // Maintain aspect ratio
              maxHeight: "none", // Prevent shrinking
              maxWidth: "none", // Prevent shrinking
            }}
          />
        </div>
      )}
    />
  )
}

export default ArticleBanner
